module.exports = new __parcel__URL__("product_2.7e934a2d.jpeg").toString();